import React, { useState } from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { CheckInCircle, Copy } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../localization/localizationHelpers";
import * as styles from "./SupportAssistant.module.css";

type CopyButtonProps = Readonly<{ label: string; text: string }>;

export const CopyButton: React.FC<CopyButtonProps> = ({ label, text }) => {
  const [copiedLabel] = useStrings("supportAssistant_copied");
  const [isCopied, setIsCopied] = useState(false);
  const copy = () => {
    navigator.clipboard
      ?.writeText(text)
      .then(() => setIsCopied(true))
      .catch(() => undefined);
  };
  return (
    <button
      type="button"
      className={styles.iconButton}
      aria-label={label}
      title={label}
      onClick={copy}
    >
      <Icon aria-hidden="true" icon={isCopied ? CheckInCircle : Copy} iconSize={IconSize.Custom} />
      <span className={styles.visuallyHidden} aria-live="polite">
        {isCopied ? copiedLabel : ""}
      </span>
    </button>
  );
};
